export const getEveryWordCapitalized = (value: string) =>
  value.replace(/(\s|^|-)([a-ząćęłńóśżź])/g, (c) => c.toUpperCase());
